
// This file is part of main.min.js which is loaded from CornellCookson.cshtml

// Add this code in an javascript widget on the product details page
/*
$(document).ready(function () {
    setProduct();
});
*/

// Called from product page
// Get product name from h1.product-title data attribute and write to cookie
function setProduct() {
    var productName = getProductNameFromMarkup();
    if (productName) {
        setProductCookie(productName);
    }
}

// Called from contact form using product dropdown field by product-dropdown-init.js
function getProduct() {

    // Read product name from h1.product-title data attribute if we're on a product page
    var productName = getProductNameFromMarkup();

    if (!productName) {
        // We're not on a product page. See if there is a `last product viewed` cookie
        productName = getProductFromCookie();
    }

    // If we were able to determine a product, try to populate the product dropdown
    if (productName) {
        setProductField(productName);
    }
}

function getProductNameFromMarkup() {
    var titles = $('h1.product-title');
    if (titles.length > 0) {
        var productName = titles.text();
        return productName;
    }
}

// Set cookie using js-cookie included in vendor.js
function setProductCookie(productName) {
    Cookies.set('CC-Last-Product-Viewed', encodeURIComponent(productName), { expires: 7 });
}

// Get cookie using js-cookie, included in vendor.js
function getProductFromCookie() {
    return decodeURIComponent(Cookies.get('CC-Last-Product-Viewed'));
}

function setProductField(productName) {
    $('.product-dropdown').val(productName);
}
